import React from 'react';

import Container from './Container';
import SwitchLink from './SwitchLink';

export default props => (
  <Container style={{marginBottom: '1rem'}}>
    <span style={{fontSize:'14px', textAlign: 'center'}}>{props.text}</span>
    <SwitchLink tabIndex={0} onClick={props.onSwitch}>
      {props.link}
    </SwitchLink>
  </Container>
);
